import React from "react";
import { COMPANY_FIELDS, FIELDS, HIDDEN, REQUIRED, STATE_LABEL, hasPf, hasPj } from "./fields";

/**
 * Miniatura do formulário como o cliente vai ver (BDM-971).
 *
 * É o que faz o público-alvo entender a configuração sem precisar imaginar o
 * resultado — por isso ela reage a cada clique, e não só depois de salvar.
 *
 * A troca entre empresa e pessoa física acontece pelo **próprio radio da
 * prévia**, e não por um controle à parte: é o mesmo gesto que o cliente vai
 * fazer no site, então não há um segundo lugar para aprender.
 */
export const Preview = ({ personTypes, fields, previewAs, onChangePreviewAs }) => {
    const showRadios = hasPj(personTypes) && hasPf(personTypes);

    const visibleFields = FIELDS.filter(field => {
        if (fields[field.key] === HIDDEN) return false;
        if (COMPANY_FIELDS.includes(field.key)) return previewAs === 'PJ';
        return true;
    });

    return (
        <div className="budget-form-preview">
            <div className="preview-head">
                <span>Prévia do seu site</span>
            </div>

            <div className="preview-browser">
                <div className="preview-chrome">
                    <i /><i /><i />
                    <span>seusite.com.br/carrinho</span>
                </div>
                <div className="preview-body">
                    <h4>Finalizar orçamento</h4>

                    {showRadios &&
                        <div className="preview-radios">
                            <button
                                type="button"
                                className={previewAs === 'PJ' ? 'on' : ''}
                                onClick={() => onChangePreviewAs('PJ')}
                                aria-pressed={previewAs === 'PJ'}
                            >
                                <i />Pessoa jurídica
                            </button>
                            <button
                                type="button"
                                className={previewAs === 'PF' ? 'on' : ''}
                                onClick={() => onChangePreviewAs('PF')}
                                aria-pressed={previewAs === 'PF'}
                            >
                                <i />Pessoa física
                            </button>
                        </div>
                    }

                    <div className="preview-fields">
                        {visibleFields.map(field => (
                            <div key={field.key} className={`preview-field ${field.wide ? 'wide' : ''}`}>
                                <label>
                                    {field.name}
                                    <em>{STATE_LABEL[fields[field.key]] ?? 'opcional'}</em>
                                </label>
                                <div className={`preview-input ${field.key === 'comments' ? 'area' : ''}`}>
                                    {field.placeholder}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* <div className="preview-consent"><i />Concordo com a Política de privacidade</div>
                    <div className="preview-cta">Finalizar orçamento</div> */}
                </div>
            </div>

            <p className="preview-note">
                {showRadios
                    ? 'Clique em "Pessoa jurídica" ou "Pessoa física" para ver os dois lados. A aparência real segue o tema do seu site.'
                    : 'A aparência real segue o tema do seu site. Aqui o que importa são os campos e a ordem.'}
            </p>
        </div>
    );
};

export const contactIsMissing = fields =>
    fields.customer_phone !== REQUIRED && fields.customer_email !== REQUIRED;

export default Preview;
